import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import styles from "./NFTModal.module.sass";
import Icon from "../../components/Icon";
import NFT from "./nft";
import { UseApi } from "../../hooks/use-api";
import { GetNFT } from "../../Services/lib/nft";
import Loader from "../Loader";
import Empthy from "../Empty";

const NFTModal = ({ visible, onClose, data: id, redeem = false }) => {
	const [{ data, isLoading }, getNFT_] = UseApi({
		service: GetNFT,
	});
	useEffect(() => {
		const target = document.querySelector("#modal-NFT");
		if (visible) {
			disableBodyScroll(target);
		} else {
			if (target) enableBodyScroll(target);
		}
	}, [visible]);

	const refresh = () => {
		getNFT_(id._id, true);
	};

	useEffect(() => {
		if (id) {
			getNFT_(id._id);
		}
	}, [id]);

	return createPortal(
		visible && (
			<div id="modal-NFT" className={styles.modal}>
				<div className={styles.control}></div>
				<div className={styles.outer}>
					{isLoading ? (
						<Loader className={styles.Loader} />
					) : data ? (
						<>
							<button className={styles.close} onClick={onClose}>
								<Icon name="close" size="20" />
							</button>
							<NFT data={data} redeem={redeem} refresh={refresh} />
						</>
					) : (
						<>
							<button className={styles.close} onClick={onClose}>
								<Icon name="close" size="20" />
							</button>
							<Empthy title="Something went wrong" />
						</>
					)}
				</div>
			</div>
		),
		document.body
	);
};

export default NFTModal;
